import { Tag } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useTranslation } from 'react-i18next';

interface IssueCategoryFilterProps {
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
}

const IssueCategoryFilter = ({ selectedCategory, onCategoryChange }: IssueCategoryFilterProps) => {
  const { t } = useTranslation('practitioners');

  const categories = [
    { key: 'all_categories', labelKey: 'issueCategoryFilter.allCategories' },
    { key: 'relationship', labelKey: 'issueCategoryFilter.relationship' },
    { key: 'emotion', labelKey: 'issueCategoryFilter.emotion' },
    { key: 'growth', labelKey: 'issueCategoryFilter.growth' },
    { key: 'work', labelKey: 'issueCategoryFilter.work' },
    { key: 'trauma', labelKey: 'issueCategoryFilter.trauma' },
    { key: 'behavior', labelKey: 'issueCategoryFilter.behavior' },
  ];

  return (
    <div>
      <h3 className="text-sm font-semibold mb-3 flex items-center">
        <Tag className="mr-2 h-4 w-4 text-amber-600" /> {t('issueCategoryFilter.title')}
      </h3>
      <Select value={selectedCategory} onValueChange={onCategoryChange}>
        <SelectTrigger className="w-full border-amber-200">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {categories.map(category => (
            <SelectItem key={category.key} value={category.key}>
              {t(category.labelKey)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default IssueCategoryFilter;
